/*
 * Planter product pages: the picked finish leads the desktop gallery.
 *
 * Each finish has one image, linked to its variants. On phones the theme's slider already
 * slides to the selected variant's image; the desktop grid does nothing with it, so a
 * finish chosen in the picker left the first finish's image at the head of the page. This
 * puts the selected variant's image first with CSS `order`, leaving the DOM (and the zoom's
 * image index) as it is.
 */
(function () {
  'use strict';

  function lead(mediaId) {
    if (!mediaId) return;

    document.querySelectorAll('.main-product__media--grid').forEach(function (grid) {
      var items = Array.prototype.slice.call(grid.querySelectorAll('.main-product__media--grid-item'));
      var active = items.find(function (item) {
        return item.querySelector('[data-media-id="' + mediaId + '"]');
      });
      if (!active) return;

      items.forEach(function (item) {
        item.style.order = item === active ? '-1' : '';
      });
    });
  }

  function selected() {
    var data = document.querySelector('product-variant-selects [data-selected-variant]');
    if (!data) return null;

    try {
      var variant = JSON.parse(data.textContent);
      return variant && variant.featured_media ? variant.featured_media.id : null;
    } catch (error) {
      return null;
    }
  }

  lead(selected());

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event && event.data ? event.data.variant : null;
      lead(variant && variant.featured_media ? variant.featured_media.id : null);
    });
  }
})();
